export default __webpack_public_path__ + "static/media/GIF2.gif?.19dde081";